<template>
  <image
    v-if="hinge"
    :href="hinge.url"
    :x="hinge.x"
    :y="hinge.y"
    :width="hinge.boxWidth"
    :height="hinge.height"
    preserveAspectRatio="xMinYMid meet"
  />
</template>

<script>
import { defineComponent } from 'vue';
import { DUET_HINGE_ASSETS } from '@framebridge/toolbox/duetHinge';

const preloadedHinges = new Set();

export default defineComponent({
  props: {
    frameSpec: {
      type: Object,
      default: null
    },
    frameSize: {
      type: Object,
      default: null
    }
  },
  computed: {
    hingeAsset () {
      const permalink = this.frameSpec?.moulding?.permalink;

      return permalink ? DUET_HINGE_ASSETS[permalink] || null : null;
    },
    hinge () {
      const asset = this.hingeAsset;
      const frameSize = this.frameSize;

      if (!asset || !frameSize || !frameSize.width || !frameSize.height) {
        return null;
      }

      return {
        url: asset.url,
        x: this.frameSpec.offsetInBundle.leftInInches + frameSize.width - asset.overlapInInches,
        y: this.frameSpec.offsetInBundle.topInInches,
        boxWidth: frameSize.width,
        height: frameSize.height
      };
    }
  },
  watch: {
    hingeAsset: {
      immediate: true,
      handler (asset) {
        if (!asset) {
          return;
        }

        Object.values(DUET_HINGE_ASSETS).forEach((hingeAsset) => this.preloadHingeAsset(hingeAsset));
      }
    }
  },
  methods: {
    preloadHingeAsset (asset) {
      if (preloadedHinges.has(asset.url)) {
        return;
      }

      preloadedHinges.add(asset.url);
      new Image().src = asset.url;
    }
  }
});
</script>
